import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, getFormValues } from 'redux-form';
import NoDataAndLoading from 'components/NoDataAndLoading';
import { showErrorNotification } from 'actions/capital';
import validate from './validate/index';
import HeaderApplication from './HeaderApplication';
import ListLenders from './ListLenders';
import Rejected from './Rejected';
import DetailForm from './DetailForm';
import Submitted from './Submitted';

class ApplicationForm extends React.Component {
  render() {
    const { applicationPage } = this.props;
    // change is reduxform function to change the field without rendering the input component, check the doc below
    // https://redux-form.com/6.2.0/docs/api/props.md/#-change-field-string-value-any-function-
    const { change } = this.props;

    return (
      <div>
        <NoDataAndLoading />
        <HeaderApplication />
        <form onSubmit={this.submitting.bind(this)}>
          {applicationPage === 1 && <ListLenders />}
          {applicationPage === 2 && <DetailForm changeField={change} />}
          {applicationPage === 3 && <Submitted />}
          {applicationPage === 4 && <Rejected />}
        </form>
      </div>
    );
  }

  submitting = e => {
    e.preventDefault();
    e.stopPropagation();
    const { syncErrors } = this.props.mokaCapitalFormState;
    if (
      syncErrors &&
      syncErrors instanceof Object &&
      Object.keys(syncErrors).length > 2
    ) {
      // there are 2 methods in syncErrors, so the length must be at least 2.
      this.props.dispatch(showErrorNotification());
    }
    this.props.handleSubmit(e);
  };
}

const mapForm = {
  form: 'mokaCapital',
  touchOnBlur: false,
  touchOnChange: true,
  destroyOnUnmount: false,
  validate,
};

function mapStateToProps(state) {
  const { applicationPage } = state.capital;
  return {
    mokaCapitalFormState: state.form.hasOwnProperty('mokaCapital')
      ? state.form.mokaCapital
      : {},
    capitalForm: getFormValues('mokaCapital')(state),
    applicationPage,
  };
}

export default connect(mapStateToProps)(reduxForm(mapForm)(ApplicationForm));
